import { useEffect } from 'react'
import { Navigate } from 'react-router'
import { localSignIn, portalSignInUrl } from '../api/client'
import { Landing } from '../pages/landing/Landing'
import { useAuth } from './AuthProvider'
import { homePathFor, LoadingScreen } from './guards'
import { useAuthEntry } from './useAuthEntry'
import { useDocumentTitle } from '../components/useDocumentTitle'

/**
 * Wejście `/` — zależne od HOSTA (decyzja właściciela 2026-09-28).
 *
 * Adres firmy (`<slug>.k1p4.cloud`) nie ma landingu: człowiek, który go
 * otwiera, przyszedł pracować, a nie czytać cennik. Bez sesji od razu rusza
 * logowanie przez portal 33rp; z sesją — panel albo portal pracownika.
 * Apeks (`k1p4.cloud`), `demo.` i pozostałe zastrzeżone etykiety zostają przy
 * landingu, bo tam nie ma obszaru, do którego można by się zalogować.
 *
 * `/login` zostaje zwykłym ekranem i NIE przekierowuje sam: tam wracają błędy
 * portalu (`?portal_error=`), a automatyczny start logowania z tego ekranu
 * zamknąłby człowieka w pętli portal → błąd → portal.
 */
export function HostEntry() {
  useDocumentTitle()
  const { session, loading, refresh } = useAuth()
  const state = useAuthEntry()

  const startPortal =
    !loading && session === null && state.status === 'ready' && state.entry.portalSignIn

  useEffect(() => {
    if (!startPortal) return
    /*
     * Obraz demonstracyjny nie ma portalu ani API (ADR-0059): zapis `/auth/entry`
     * mówi „adres firmy z portalem", więc bez tego wyjścia wejście na `/`
     * nawigowało pod `/api/v1/auth/portal` i kończyło się stroną 502 proxy.
     * W demo wchodzimy lokalnie, jak ekran logowania, a po sesji `Navigate`
     * niżej prowadzi do panelu.
     */
    const signInHere = localSignIn()
    if (signInHere) {
      void signInHere(null).then(() => refresh())
      return
    }
    /*
     * Pełna nawigacja, nie router: ścieżka wychodzi z aplikacji (serwer
     * odpowiada przekierowaniem na portal — patrz komentarz w Login.tsx).
     * `replace`, żeby „Wstecz" z portalu nie wracało tu i nie odbijało
     * człowieka z powrotem do portalu.
     */
    window.location.replace(portalSignInUrl(null))
  }, [startPortal, refresh])

  if (loading || state.status === 'loading') return <LoadingScreen />
  if (session) return <Navigate to={homePathFor(session.user.roles)} replace />
  if (startPortal) return <LoadingScreen />
  /* Adres firmy, ale portal nie jest skonfigurowany — ekran logowania mówi to wprost. */
  if (state.status === 'ready' && state.entry.tenantHost) return <Navigate to="/login" replace />
  return <Landing />
}
